import React from 'react';
import Context from '../../assets/js/Context';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';
import { Row, Col, Spinner } from 'react-bootstrap';
import Login from '../common/login';

const cookies = new Cookies();
const role = Number(localStorage.getItem('role'));

class Selles_Reports extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: [],
      filteredOrders: [], // للبيانات المفلترة
      pages: [],
      page: 'كل الصفحات',
      pageId: 'All',
      loading: false,
      total_orders: 0,
      total_items: 0,
      items_cost: 0,
      orders_cost: 0,
      searchTerm: '', // مصطلح البحث
      isSearching: false // حالة البحث
    };
  }

  componentDidMount() {
    this.fetchData("All");
  }

  fetchData = (pageId) => {
    this.setState({ loading: true });
    const header = { "Content-Type": "application/json", token: cookies.get("token") };

    axios.get(`${host}users/printed/orders/watting/reports?page=${pageId}&status=-2`, { headers: header })
      .then(res => {
        const items = res.data.data.items.map((item, i) => ({
          id: i + 1,
          name: item.components_name,
          count: item.count
        }));
        this.setState({
          orders: items,
          filteredOrders: items, // تعيين البيانات المفلترة أيضاً
          total_items: res.data.data.items_sum,
          total_orders: res.data.data.orders_count,
          items_cost: res.data.data.items_cost,
          orders_cost: res.data.data.sells,
          loading: false
        });
      });

    axios.get(`${host}users/pages/name/all`, { headers: header })
      .then(res => {
        this.setState({ pages: res.data.data.pages });
      });
  };

  handlePageChange = (e) => {
    const selected = e.target.value;
    const text = e.target.options[e.target.selectedIndex].text;
    this.setState({ page: text, pageId: selected, searchTerm: '', isSearching: false }, () => {
      this.fetchData(selected);
    });
  }

  // دالة البحث
  handleSearch = (e) => {
    const searchTerm = e.target.value.toLowerCase().trim();
    this.setState({ searchTerm });

    if (searchTerm === '') {
      // إذا كان البحث فارغاً، أعرض جميع البيانات
      this.setState({ 
        filteredOrders: this.state.orders,
        isSearching: false 
      });
    } else {
      // فلترة البيانات بناءً على اسم المنتج
      const filtered = this.state.orders.filter(order =>
        order.name.toLowerCase().includes(searchTerm)
      );
      this.setState({ 
        filteredOrders: filtered,
        isSearching: true 
      });
    }
  }

  // مسح البحث
  clearSearch = () => {
    this.setState({ 
      searchTerm: '', 
      filteredOrders: this.state.orders,
      isSearching: false 
    });
  }

  // دالة لتسليط الضوء على النص المطابق للبحث
  highlightSearchTerm = (text) => {
    if (!this.state.searchTerm || !this.state.isSearching) {
      return text;
    }

    const searchTerm = this.state.searchTerm;
    const regex = new RegExp(`(${searchTerm})`, 'gi');
    const parts = text.split(regex);
    
    return parts.map((part, index) =>
      regex.test(part) ? (
        <span key={index} className="search-highlight">
          {part}
        </span>
      ) : part
    );
  }

  render() {
    if (!cookies.get("token")) return <Login />;

    const statsCards = [
      {
        title: "مجموع الطلبات",
        value: this.state.total_orders,
        icon: "📦",
        gradient: "linear-gradient(135deg, #06b6d4, #0891b2)",
        shadowColor: "rgba(6, 182, 212, 0.3)"
      },
      {
        title: "مجموع القطع",
        value: this.state.total_items,
        icon: "🧾",
        gradient: "linear-gradient(135deg, #8b5cf6, #7c3aed)",
        shadowColor: "rgba(139, 92, 246, 0.3)"
      },
      ...(role === -1 ? [{
        title: "أسعار المواد",
        value: this.state.items_cost,
        icon: "💰",
        gradient: "linear-gradient(135deg, #f59e0b, #d97706)",
        shadowColor: "rgba(245, 158, 11, 0.3)"
      }] : []),
      ...(role !== 0 ? [{
        title: "مجموع المبيعات",
        value: this.state.orders_cost,
        icon: "💸",
        gradient: "linear-gradient(135deg, #ef4444, #dc2626)",
        shadowColor: "rgba(239, 68, 68, 0.3)"
      }] : [])
    ];

    return (
      <Context.Consumer>
        {ctx => (
          <div style={{
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
            padding: '16px',
            fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
            direction: 'rtl'
          }}>
            <style>
              {`
                @keyframes spin {
                  from { transform: rotate(0deg); }
                  to { transform: rotate(360deg); }
                }
                
                @keyframes slideIn {
                  from { opacity: 0; transform: translateY(-20px); }
                  to { opacity: 1; transform: translateY(0); }
                }
                
                @keyframes fadeIn {
                  from { opacity: 0; }
                  to { opacity: 1; }
                }
                
                @keyframes pulse {
                  0%, 100% { opacity: 1; }
                  50% { opacity: 0.7; }
                }
                
                .form-control {
                  width: 100%;
                  padding: 12px 16px;
                  border: 2px solid #e2e8f0;
                  border-radius: 12px;
                  font-size: 14px;
                  background: white;
                  transition: all 0.2s ease;
                  box-sizing: border-box;
                  height: 50px;
                }
                
                .form-control:focus {
                  outline: none;
                  border-color: #8b5cf6;
                  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.1);
                }
                
                .search-highlight {
                  background-color: rgba(139, 92, 246, 0.2);
                  color: #6b46c1;
                  font-weight: 600;
                  padding: 1px 3px;
                  border-radius: 3px;
                }
                
                .stats-card {
                  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                }
                
                .stats-card:hover {
                  transform: translateY(-8px) scale(1.02);
                }
                
                @media (max-width: 768px) {
                  .form-control {
                    padding: 10px 12px;
                    font-size: 16px;
                    height: 50px;
                  }
                  
                  .stats-grid {
                    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr)) !important;
                    gap: 12px !important;
                  }
                  
                  .stats-card {
                    padding: 16px !important;
                  }
                  
                  .stats-card .icon {
                    font-size: 20px !important;
                    margin-bottom: 6px !important;
                  }
                  
                  .stats-card .value {
                    font-size: 18px !important;
                    margin-bottom: 4px !important;
                  }
                  
                  .stats-card .title {
                    font-size: 11px !important;
                  }
                  
                  .desktop-table {
                    display: none !important;
                  }
                  
                  .mobile-cards {
                    display: block !important;
                  }
                }
                
                @media (min-width: 769px) {
                  .desktop-table {
                    display: block !important;
                  }
                  
                  .mobile-cards {
                    display: none !important;
                  }
                }
                
                @media (max-width: 480px) {
                  .stats-grid {
                    grid-template-columns: repeat(2, 1fr) !important;
                  }
                }
                
                .loading-spinner {
                  animation: spin 1s linear infinite;
                }
                
                .loading-pulse {
                  animation: pulse 2s infinite;
                }
              `}
            </style>

            <div style={{
              maxWidth: '1400px',
              margin: '0 auto',
              background: 'rgba(255, 255, 255, 0.95)',
              backdropFilter: 'blur(10px)',
              borderRadius: '24px',
              padding: 'clamp(16px, 4vw, 32px)',
              boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
              animation: 'slideIn 0.6s ease-out'
            }}>
              {/* Back Button */}
              <button
                onClick={() => window.history.back()}
                style={{
                  background: 'linear-gradient(135deg, #8b5cf6, #7c3aed)',
                  color: "white",
                  padding: "12px 24px",
                  border: "none",
                  borderRadius: '16px',
                  fontSize: 14,
                  fontWeight: '600',
                  cursor: "pointer",
                  boxShadow: "0 4px 14px 0 rgba(139, 92, 246, 0.3)",
                  transition: 'all 0.2s ease',
                  marginBottom: '24px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 6px 20px 0 rgba(139, 92, 246, 0.4)';
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 14px 0 rgba(139, 92, 246, 0.3)';
                }}
              >
                <span style={{ fontSize: '16px' }}>←</span>
                رجوع
              </button>

              {/* Header */}
              <div style={{
                background: 'linear-gradient(135deg, #8b5cf6, #7c3aed)',
                color: "white",
                padding: 'clamp(20px, 5vw, 32px)',
                borderRadius: '20px',
                marginBottom: '32px',
                textAlign: 'center',
                position: 'relative',
                overflow: 'hidden'
              }}>
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: 'linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.1) 50%, transparent 70%)',
                  animation: 'slideIn 2s ease-in-out infinite alternate'
                }}></div>
                <h1 style={{
                  margin: 0,
                  fontSize: 'clamp(20px, 5vw, 32px)',
                  fontWeight: '700',
                  position: 'relative',
                  zIndex: 1
                }}>
                  ❓ تقارير غير مؤكد - {this.state.page}
                </h1>
                <p style={{
                  margin: '8px 0 0 0',
                  opacity: 0.9,
                  fontSize: 'clamp(14px, 3vw, 16px)',
                  position: 'relative',
                  zIndex: 1
                }}>
                  تحليل الطلبات التي تحتاج إلى تأكيد ومراجعة
                </p>
              </div>

              {/* Search Section */}
              <div style={{
                background: 'linear-gradient(135deg, #ede9fe, #ddd6fe)',
                padding: '24px',
                borderRadius: '16px',
                border: '1px solid #c4b5fd',
                marginBottom: '24px'
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  flexWrap: 'wrap'
                }}>
                  <div style={{
                    position: 'relative',
                    flex: '1',
                    minWidth: '250px'
                  }}>
                    <input
                      type="text"
                      placeholder="🔍 ابحث عن منتج..."
                      value={this.state.searchTerm}
                      onChange={this.handleSearch}
                      className="form-control"
                      style={{
                        paddingLeft: this.state.searchTerm ? '45px' : '16px',
                        fontSize: '16px'
                      }}
                    />
                    {this.state.searchTerm && (
                      <button
                        onClick={this.clearSearch}
                        style={{
                          position: 'absolute',
                          left: '12px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          background: 'none',
                          border: 'none',
                          fontSize: '18px',
                          cursor: 'pointer',
                          color: '#6b7280',
                          padding: '4px',
                          borderRadius: '4px',
                          transition: 'all 0.2s ease'
                        }}
                        onMouseOver={(e) => {
                          e.target.style.background = '#f3f4f6';
                          e.target.style.color = '#374151';
                        }}
                        onMouseOut={(e) => {
                          e.target.style.background = 'none';
                          e.target.style.color = '#6b7280';
                        }}
                      >
                        ×
                      </button>
                    )}
                  </div>
                  
                  {this.state.isSearching && (
                    <div style={{
                      background: 'rgba(139, 92, 246, 0.1)',
                      color: '#6b46c1',
                      padding: '8px 12px',
                      borderRadius: '20px',
                      fontSize: '14px',
                      fontWeight: '600',
                      border: '1px solid rgba(139, 92, 246, 0.2)'
                    }}>
                      {this.state.filteredOrders.length} نتيجة من أصل {this.state.orders.length}
                    </div>
                  )}
                </div>
              </div>
              {/* Page Selection */}
              <div style={{
                background: 'linear-gradient(135deg, #ede9fe, #ddd6fe)',
                padding: '24px',
                borderRadius: '16px',
                border: '1px solid #c4b5fd',
                marginBottom: '32px',
                textAlign: 'center'
              }}>
                <label style={{
                  fontWeight: "600",
                  color: '#6b46c1',
                  display: 'block',
                  marginBottom: '12px',
                  fontSize: '16px'
                }}>
                  📄 اختر الصفحة للتحليل:
                </label>
                <select
                  value={this.state.pageId}
                  onChange={this.handlePageChange}
                  className="form-control"
                  style={{
                    maxWidth: '400px',
                    margin: '0 auto'
                  }}
                >
                  <option value="All">كل الصفحات</option>
                  {this.state.pages.map(p => (
                    <option key={p.id} value={p.id}>{p.name}</option>
                  ))}
                </select>
              </div>

              {/* Loading State */}
              {this.state.loading ? (
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '80px 20px',
                  background: 'linear-gradient(135deg, #ede9fe, #ddd6fe)',
                  borderRadius: '20px',
                  border: '1px solid #c4b5fd'
                }}>
                  <div style={{
                    width: '60px',
                    height: '60px',
                    border: '4px solid #ddd6fe',
                    borderTop: '4px solid #8b5cf6',
                    borderRadius: '50%',
                    marginBottom: '20px'
                  }} className="loading-spinner"></div>
                  <div style={{
                    fontSize: '18px',
                    fontWeight: '600',
                    color: '#6b46c1',
                    marginBottom: '8px'
                  }} className="loading-pulse">
                    جاري تحميل البيانات...
                  </div>
                  <div style={{
                    fontSize: '14px',
                    color: '#7c3aed'
                  }}>
                    يرجى الانتظار قليلاً
                  </div>
                </div>
              ) : (
                <div style={{ animation: 'fadeIn 0.5s ease-out' }}>
                  {/* Statistics Cards */}
                  <div className="stats-grid" style={{
                    display: 'grid',
                    gridTemplateColumns: `repeat(${statsCards.length}, 1fr)`,
                    gap: '20px',
                    marginBottom: '32px'
                  }}>
                    {statsCards.map((card, index) => (
                      <div 
                        key={index}
                        className="stats-card"
                        style={{
                          background: card.gradient,
                          color: "white",
                          padding: '24px',
                          borderRadius: '20px',
                          textAlign: 'center',
                          boxShadow: `0 8px 25px -5px ${card.shadowColor}`,
                          minHeight: '140px',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}
                      >
                        <div className="icon" style={{ 
                          fontSize: '28px', 
                          marginBottom: '8px' 
                        }}>
                          {card.icon}
                        </div>
                        <div className="value" style={{ 
                          fontSize: 'clamp(20px, 4vw, 24px)', 
                          fontWeight: '700', 
                          marginBottom: '4px',
                          lineHeight: 1
                        }}>
                          {card.value.toLocaleString()}
                        </div>
                        <div className="title" style={{ 
                          opacity: 0.9, 
                          fontSize: 'clamp(12px, 2.5vw, 14px)',
                          lineHeight: 1.2,
                          fontWeight: '500'
                        }}>
                          {card.title}
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Data Table */}
                  <div style={{
                    background: 'white',
                    borderRadius: '20px',
                    overflow: 'hidden',
                    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
                    border: '1px solid #e5e7eb',
                    width: '100%'
                  }}>
                    {/* Table Header */}
                    <div style={{
                      background: 'linear-gradient(135deg, #8b5cf6, #7c3aed)',
                      color: 'white',
                      padding: '20px 24px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      borderBottom: '2px solid #e5e7eb'
                    }}>
                      <h3 style={{
                        margin: 0,
                        fontSize: '18px',
                        fontWeight: '700',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                      }}>
                        ❓ الطلبات غير المؤكدة
                      </h3>
                      <div style={{
                        fontSize: '14px',
                        background: 'rgba(255, 255, 255, 0.2)',
                        padding: '6px 12px',
                        borderRadius: '20px',
                        backdropFilter: 'blur(10px)'
                      }}>
                        {this.state.isSearching ? this.state.filteredOrders.length : this.state.orders.length} طلب
                        {this.state.isSearching && (
                          <span style={{ fontSize: '12px', opacity: 0.8 }}>
                            {' '}من أصل {this.state.orders.length}
                          </span>
                        )}
                      </div>
                    </div>

                    {this.state.filteredOrders.length === 0 ? (
                      <div style={{
                        padding: '60px 20px',
                        textAlign: 'center',
                        color: '#6b7280'
                      }}>
                        <div style={{
                          fontSize: '48px',
                          marginBottom: '16px'
                        }}>
                          {this.state.isSearching ? '🔍' : '✅'}
                        </div>
                        <div style={{
                          fontSize: '18px',
                          fontWeight: '600',
                          marginBottom: '8px'
                        }}>
                          {this.state.isSearching 
                            ? `لم يتم العثور على منتجات تحتوي على "${this.state.searchTerm}"`
                            : 'لا توجد طلبات غير مؤكدة'
                          }
                        </div>
                        <div style={{
                          fontSize: '14px'
                        }}>
                          {this.state.isSearching 
                            ? 'جرب البحث بكلمات مختلفة'
                            : 'جميع الطلبات تم تأكيدها بنجاح'
                          }
                        </div>
                        {this.state.isSearching && (
                          <button
                            onClick={this.clearSearch}
                            style={{
                              marginTop: '16px',
                              background: 'linear-gradient(135deg, #8b5cf6, #7c3aed)',
                              color: 'white',
                              border: 'none',
                              padding: '8px 16px',
                              borderRadius: '8px',
                              cursor: 'pointer',
                              fontSize: '14px',
                              fontWeight: '600'
                            }}
                          >
                            مسح البحث
                          </button>
                        )}
                      </div>
                    ) : (
                      <>
                        {/* Desktop Table View */}
                        <div className="desktop-table">
                          <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            fontSize: '14px'
                          }}>
                            <thead>
                              <tr style={{
                                background: '#ede9fe',
                                borderBottom: '2px solid #ddd6fe'
                              }}>
                                <th style={{
                                  padding: '16px 20px',
                                  textAlign: 'center',
                                  fontWeight: '700',
                                  color: '#6b46c1',
                                  fontSize: '15px',
                                  width: '80px'
                                }}>#</th>
                                <th style={{
                                  padding: '16px 20px',
                                  textAlign: 'right',
                                  fontWeight: '700',
                                  color: '#6b46c1',
                                  fontSize: '15px'
                                }}>اسم المنتج</th>
                                <th style={{
                                  padding: '16px 20px',
                                  textAlign: 'center',
                                  fontWeight: '700',
                                  color: '#6b46c1',
                                  fontSize: '15px',
                                  width: '120px'
                                }}>العدد</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.filteredOrders.map((order, index) => (
                                <tr key={index} style={{
                                  borderBottom: '1px solid #f1f5f9',
                                  backgroundColor: index % 2 === 0 ? '#ffffff' : '#faf9ff',
                                  transition: 'all 0.2s ease'
                                }}
                                onMouseOver={(e) => {
                                  e.currentTarget.style.backgroundColor = '#f3f4f6';
                                  e.currentTarget.style.transform = 'scale(1.01)';
                                }}
                                onMouseOut={(e) => {
                                  e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#faf9ff';
                                  e.currentTarget.style.transform = 'scale(1)';
                                }}>
                                  <td style={{
                                    padding: '16px 20px',
                                    textAlign: 'center',
                                    fontWeight: '600',
                                    color: '#6b7280'
                                  }}>
                                    <span style={{
                                      background: 'linear-gradient(135deg, #8b5cf6, #7c3aed)',
                                      color: 'white',
                                      padding: '4px 8px',
                                      borderRadius: '8px',
                                      fontSize: '12px',
                                      fontWeight: '600'
                                    }}>
                                      {order.id}
                                    </span>
                                  </td>
                                  <td style={{
                                    padding: '16px 20px',
                                    textAlign: 'right',
                                    color: '#374151',
                                    fontWeight: '500'
                                  }}>
                                    {this.highlightSearchTerm(order.name)}
                                  </td>
                                  <td style={{
                                    padding: '16px 20px',
                                    textAlign: 'center',
                                    fontWeight: '600'
                                  }}>
                                    <span style={{
                                      background: 'linear-gradient(135deg, #8b5cf6, #7c3aed)',
                                      color: 'white',
                                      padding: '6px 12px',
                                      borderRadius: '12px',
                                      fontSize: '13px',
                                      fontWeight: '600'
                                    }}>
                                      {order.count}
                                    </span>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>

                        {/* Mobile Cards View */}
                        <div className="mobile-cards">
                          {this.state.filteredOrders.map((order, index) => (
                            <div key={index} style={{
                              margin: '16px',
                              background: 'linear-gradient(135deg, #ede9fe, #ddd6fe)',
                              border: '1px solid #c4b5fd',
                              borderRadius: '16px',
                              overflow: 'hidden',
                              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
                              transition: 'all 0.3s ease'
                            }}
                            onTouchStart={(e) => {
                              e.currentTarget.style.transform = 'scale(0.98)';
                            }}
                            onTouchEnd={(e) => {
                              e.currentTarget.style.transform = 'scale(1)';
                            }}>
                              <div style={{
                                background: 'linear-gradient(135deg, #8b5cf6, #7c3aed)',
                                color: 'white',
                                padding: '12px 16px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                              }}>
                                <span style={{
                                  fontSize: '14px',
                                  fontWeight: '600'
                                }}>
                                  الطلب #{order.id}
                                </span>
                                <span style={{
                                  background: 'rgba(255, 255, 255, 0.2)',
                                  padding: '4px 8px',
                                  borderRadius: '8px',
                                  fontSize: '12px',
                                  fontWeight: '600'
                                }}>
                                  العدد: {order.count}
                                </span>
                              </div>
                              <div style={{
                                padding: '16px',
                                textAlign: 'right'
                              }}>
                                <div style={{
                                  fontSize: '16px',
                                  fontWeight: '600',
                                  color: '#6b46c1',
                                  lineHeight: '1.5'
                                }}>
                                  {this.highlightSearchTerm(order.name)}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>

                        {/* Enhanced Pagination */}
                        <div style={{
                          background: '#ede9fe',
                          padding: '20px 24px',
                          borderTop: '1px solid #c4b5fd',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          flexWrap: 'wrap',
                          gap: '12px'
                        }}>
                          <div style={{
                            fontSize: '14px',
                            color: '#6b46c1',
                            fontWeight: '500'
                          }}>
                            عرض 1-{this.state.filteredOrders.length} من {this.state.filteredOrders.length} طلب
                            {this.state.isSearching && (
                              <span style={{ fontSize: '12px', opacity: 0.8 }}>
                                {' '}(مفلتر من أصل {this.state.orders.length})
                              </span>
                            )}
                          </div>
                          <div style={{
                            display: 'flex',
                            gap: '8px',
                            alignItems: 'center'
                          }}>
                            <button style={{
                              background: 'linear-gradient(135deg, #8b5cf6, #7c3aed)',
                              color: 'white',
                              border: 'none',
                              padding: '8px 16px',
                              borderRadius: '8px',
                              fontSize: '12px',
                              fontWeight: '600',
                              cursor: 'pointer',
                              transition: 'all 0.2s ease'
                            }}
                            onMouseOver={(e) => {
                              e.target.style.transform = 'translateY(-1px)';
                              e.target.style.boxShadow = '0 4px 12px rgba(139, 92, 246, 0.3)';
                            }}
                            onMouseOut={(e) => {
                              e.target.style.transform = 'translateY(0)';
                              e.target.style.boxShadow = 'none';
                            }}>
                              📥 تحميل التقرير
                            </button>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </Context.Consumer>
    );
  }
}

export default Selles_Reports;